<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('applyPrognosis')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						:disabled="isApplyProgButtonDisabled"
						@click="prognoseAplica"
					/>
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVVincularPrognose()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:key="tableKey"
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotalPagination.items"
			:table-configuration="tableConfiguration"
			:mostrar-btn-editar="false"
			:show-sort-options="true"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		/>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				:reset-index-on-batch-change="false"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<DropdownFk
					v-model="model.prognoseEscolhida"
					:label="$t('prognosis')"
					:dropdown-options="formatedPrognose"
				/>
				<InputText
					v-model="model.horizonteDeProjecao"
					:label="`${$t('projectionHorizon')} (${$t('months')})`"
				/>
				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="!camposObrigatorios"
						:loading="aplicandoPrognose"
						@click="saveClick"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import GridPagination from '../../../components/GridPagination/GridPagination'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import { getAllAplicaPrognose, getAllPrognose } from '../../../services/requests/PrognoseRequests'
import { vinculaPrognose } from '../../../services/requests/VinculaPrognoseRequests'

import download from 'downloadjs'

export default {
	components: {
		Button,
		CrudTable,
		CrudForm,
		InputText,
		DropdownCheckbox,
		InputSearch,
		GridPagination,
		DropdownFk,
	},
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			aplicandoPrognose: false,
			isApplyProgButtonDisabled: false,
			totalRecords: 0,
			batchSize: 100,
			actualBatchSize: null, // Tamanho real retornado pelo backend
			allLoadedData: [],
			isLoadingMore: false,
			currentStartIndex: 0,
			currentEndIndex: 10,
			headersSelecionados: [
				'prognoseDescricao',
				'inventarioFlorestalDescricao',
				'idade',
				'dataDoPlantio',
				'plantioCodigo',
				'estratoDescricao',
				'fazendaDescricao',
			],
			teste: false,
			prognose: [],
			model: {
				prognoseEscolhida: null,
				horizonteDeProjecao: 0,
			},
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'descricao',
				titleCardPropertie: 'codigo',
			},

			tableHeaders: [
				{ key: 'fazendaDescricao', value: this.$t('farm'), isActive: true },
				{
					key: 'estratoDescricao',
					value: this.$t('forestStratification'),
					isActive: true,
				},
				{
					key: 'plantioCodigo',
					value: this.$t('plantation'),
					isActive: true,
				},
				{
					key: 'dataDoPlantio',
					value: this.$t('plantationDate'),
					isActive: true,
				},
				{
					key: 'idade',
					value: `${this.$t('plantationAge')} (${this.$t('months')})`,
					isActive: true,
				},
				{
					key: 'inventarioFlorestalDescricao',
					value: this.$t('forestInventory'),
					isActive: true,
				},
				{
					key: 'isSingleTrees',
					value: `${this.$t('singleTrees')}?`,
					isActive: false,
				},
				{ key: 'sitio', value: this.$t('site'), isActive: false },
				{
					key: 'prognoseDescricao',
					value: this.$t('prognosis'),
					isActive: true,
				},
			],
		}
	},
	computed: {
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},

		camposObrigatorios() {
			return this.model.prognoseEscolhida && this.model.horizonteDeProjecao
		},

		formatedPrognose() {
			return this.prognose.map((m) => {
				return {
					id: m.id,
					[this.$t('code')]: m.codigo,
					[this.$t('description')]: m.descricao,
					[this.$t('date')]: new Date(m.dataDaPrognose).toLocaleString(),
					[this.$t('siteClassification')]: m.classificacaoDeSitioCodigo,
				}
			})
		},
		paginatedData() {
			return this.allLoadedData.slice(this.currentStartIndex, this.currentEndIndex)
		},
		tableKey() {
			// Chave única que força re-renderização quando dados ou índices mudam
			return `${this.modelList.length}-${this.atualStartIndex}-${this.atualEndIndex}`
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		modelList: {
			handler() {
				//  this.handleSelectionChanges();
				//const checadas = this.modelList.filter((f) => f.isCheckedToDelete);
				// var idades = checadas.map((m) => m.idade);
				// this.model.horizonteDeProjecao = Math.max.apply(null, idades);
				this.isApplyProgButtonDisabled =
					this.modelList.filter((f) => f.isCheckedToDelete).length === 0
			},
			deep: true,
		},
		textFilter(value) {
			// Remove espaços no início e no final
			const trimmedValue = value ? value.trim() : ''
			if (trimmedValue !== value) {
				this.textFilter = trimmedValue
				return
			}

			this.$refs.ref__pagination.resetToFirstPageInputHandle()
			if (trimmedValue) {
				// Com filtro, busca no servidor
				this.refreshTabela(0, this.quantityPerPage, trimmedValue)
			} else {
				// Sem filtro, recarrega dados iniciais
				this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
				this.modelList = []
				this.currentStartIndex = 0
				this.currentEndIndex = this.quantityPerPage
				this.atualStartIndex = 0
				this.atualEndIndex = this.quantityPerPage
				getAllAplicaPrognose(0, this.batchSize, '').then((response) => {
					this.totalRecords = response.data.totalRegistros || 0
					const plantios = response.data.result
					if (plantios && plantios.length > 0) {
						// Guarda o tamanho real retornado pelo backend
						this.actualBatchSize = plantios.length
						plantios.forEach((plantio) => this.formatarDados(plantio))
						this.allLoadedData = plantios
						this.modelList = plantios
					}
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
				})
			}
		},
	},
	created() {
		this.quantityPerPage = 10
		getAllPrognose().then((response) => {
			const result = response.data
			this.prognose = result
		})

		getAllAplicaPrognose(0, this.batchSize, '').then((response) => {
			this.totalRecords = response.data.totalRegistros || 0
			const plantios = response.data.result
			if (plantios && plantios.length > 0) {
				// Guarda o tamanho real retornado pelo backend
				this.actualBatchSize = plantios.length
				plantios.forEach((plantio) => this.formatarDados(plantio))
				this.allLoadedData = plantios
				this.modelList = plantios
			}
			this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
		})
	},
	methods: {
		// Sobrescreve o método do mixin para sincronizar os índices locais
		setStartEnd(startIndex) {
			this.atualStartIndex = startIndex
			this.atualEndIndex = startIndex + this.quantityPerPage
			this.currentStartIndex = startIndex
			this.currentEndIndex = startIndex + this.quantityPerPage
		},
		// Sobrescreve o método do mixin para atualizar a quantidade por página
		setQuantityPerPage(quantityPerPage) {
			this.quantityPerPage = quantityPerPage
			// Recalcula o endIndex com a nova quantidade
			this.atualEndIndex = this.atualStartIndex + quantityPerPage
			this.currentEndIndex = this.currentStartIndex + quantityPerPage
		},
		formatarDados(vinculaDados) {
			vinculaDados.idade = Number(vinculaDados.idade?.toFixed(0))
			vinculaDados.dataDoPlantio = new Date(vinculaDados.dataDoPlantio).toLocaleDateString()
			vinculaDados.isCheckedToDelete = false
		},
		refreshTabela(pageNumber, pageSize, filteringWord) {
			// Se tem filtro, faz busca nova no servidor
			if (filteringWord) {
				this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
				this.modelList = []
				this.currentStartIndex = 0
				this.currentEndIndex = this.quantityPerPage
				this.atualStartIndex = 0
				this.atualEndIndex = this.quantityPerPage
				getAllAplicaPrognose(0, this.batchSize, filteringWord).then((response) => {
					this.totalRecords = response.data.totalRegistros || 0
					const plantios = response.data.result
					if (!plantios || plantios.length === 0) {
						this.modelList = []
						this.allLoadedData = []
						this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
						return
					}
					// Guarda o tamanho real retornado pelo backend
					this.actualBatchSize = plantios.length
					plantios.forEach((plantio) => this.formatarDados(plantio))
					this.allLoadedData = plantios
					// modelList contém todos os dados carregados, o computed faz o slice para exibição
					this.modelList = plantios
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
				})
				return
			}

			this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
			this.modelList = []

			// Calcula quantos dados já foram carregados do backend
			const dadosCarregados = this.allLoadedData.length
			// Calcula quanto dado do backend precisamos ter carregado para exibir a página atual
			// Usa os índices de exibição que já foram setados pelo setStartEnd
			const endIndexNecessario = this.currentEndIndex

			// Se não tem dados carregados mas precisa exibir, carrega os dados iniciais
			if (dadosCarregados === 0 && endIndexNecessario > 0) {
				this.loadInitialData()
				return
			}

			// Se precisa de mais dados do que já carregou
			if (endIndexNecessario > dadosCarregados && dadosCarregados < this.totalRecords) {
				this.loadMoreData()
			} else {
				// Dados já carregados, restaura modelList
				this.modelList = this.allLoadedData
				this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
			}
			// O computed modelsToBeShowedAndTotalPagination faz o slice automaticamente
		},
		loadInitialData() {
			if (this.isLoadingMore) return

			this.isLoadingMore = true
			getAllAplicaPrognose(0, this.batchSize, '')
				.then((response) => {
					this.totalRecords = response.data.totalRegistros || 0
					const plantios = response.data.result
					if (plantios && plantios.length > 0) {
						// Guarda o tamanho real retornado pelo backend
						this.actualBatchSize = plantios.length
						plantios.forEach((plantio) => this.formatarDados(plantio))
						this.allLoadedData = plantios
						// modelList contém todos os dados carregados, o computed faz o slice para exibição
						this.modelList = plantios
					}
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
				.catch(() => {
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
		},
		loadMoreData() {
			if (this.isLoadingMore) return

			this.isLoadingMore = true
			this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
			this.modelList = []
			// Para paginação zero-based: página 0 = primeiros registros, página 1 = próximos, etc.
			// Usa o tamanho real retornado pelo backend para calcular a página correta
			const batchSizeReal = this.actualBatchSize || this.batchSize
			const pageNumber = Math.floor(this.allLoadedData.length / batchSizeReal)

			getAllAplicaPrognose(pageNumber, this.batchSize, '')
				.then((response) => {
					const plantios = response.data.result
					if (plantios && plantios.length > 0) {
						plantios.forEach((plantio) => this.formatarDados(plantio))
						// Concatena os novos dados
						this.allLoadedData = this.allLoadedData.concat(plantios)
						// modelList contém todos os dados carregados, o computed faz o slice para exibição
						this.modelList = this.allLoadedData
					}
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
				.catch(() => {
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
		},
		saveClick() {
			this.aplicandoPrognose = true
			console.log(
				'🚀 ~ file: Vincular.vue:192 ~ saveClick ~ this.aplicandoPrognose:',
				this.aplicandoPrognose,
			)
			const checadas = this.modelList.filter((f) => f.isCheckedToDelete)
			var idades = checadas.map((m) => m.idade)
			var idadeMax = Math.max.apply(null, idades)

			if (this.model.horizonteDeProjecao <= idadeMax) {
				this.teste = true
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: this.$t('horizonteDeProjecao'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})

				this.aplicandoPrognose = false
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('sucesso'),
					messageText: this.$t('processingLinkPlantings'),
					messageIcon: 'far fa-check-circle',
					messageType: 'success',
				})

				this.showForm = false
				// Busca a lista de plantios que serao aplicadas a prognose para arrumar a data do plantio
				const plantios = this.modelList.filter((f) => f.isCheckedToDelete)
				plantios.forEach((plantio) => {
					var dataParticionada = plantio.dataDoPlantio.split('/')
					plantio.dataDoPlantio = `${dataParticionada[1]}/${dataParticionada[0]}/${dataParticionada[2]}`
					if (dataParticionada[1] > 12) {
						plantio.dataDoPlantio = `${dataParticionada[0]}/${dataParticionada[1]}/${dataParticionada[2]}`
					}
				})

				vinculaPrognose({
					prognoseId: this.model.prognoseEscolhida,
					IdadeDeProjecao: Number(this.model.horizonteDeProjecao),
					AplicacaoDaPrognose: plantios,
				})
					.then((response) => {
						const { result: message } = response.data
						console.log('response', response.data)
						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
							messageText: message,
						})
						this.showForm = false
						this.cleanModel()
						this.modelList.forEach((f) => (f.isCheckedToDelete = false))
						window.location.reload()
						this.aplicandoPrognose = false
					})
					.catch(() => {
						this.aplicandoPrognose = false
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
							messageText: this.$t('erro_vincular_prognose'),
						})
					})
			}
		},
		prognoseAplica() {
			this.handleSelectionChanges()
			this.titleForm = 'Aplica Prognose'
			this.changeFormAndCloseAllActions()
		},
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
		handleSelectionChanges() {
			const checadas = this.modelList.filter((f) => f.isCheckedToDelete)
			var idades = checadas.map((m) => (m.idade !== undefined ? m.idade : 0))

			if (idades.length > 0) {
				this.model.horizonteDeProjecao = Math.max.apply(null, idades)
			} else {
				console.error('Não há idades válidas para calcular o máximo.')
			}
		},

		/**
		 * Baixa CSV com os dados da tabela de vincula prognose
		 */
		downloadCSVVincularPrognose() {
			let cabecalhoDoCsvVincularPrognose = [
				'Fazenda',
				'Estrato Florestal',
				'Plantio',
				'Data do Plantio',
				'Idade do Plantio (Meses)',
				'Inventário Florestal',
				'Single Trees',
				'Sítio',
				'Prognose',
			]
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvVincularPrognose,
				...items.map((item) => [
					item.fazendaDescricao,
					item.estratoDescricao,
					item.plantioCodigo,
					item.dataDoPlantio,
					item.idade,
					item.inventarioFlorestalDescricao,
					item.isSingleTrees,
					item.sitio,
					item.prognoseDescricao,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_vincula_prognose.csv', 'text/csv')
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
